import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/marketing/Navbar';
import Footer from '../../components/marketing/Footer';

const PricingPage: React.FC = () => {
	useEffect(() => {
		document.title = 'Pricing — Sedra Invoices';
	}, []);

	return (
		<div className="min-h-screen flex flex-col bg-white">
			<Navbar />
			<main id="main" className="flex-1">
				<section className="mx-auto max-w-7xl px-6 lg:px-8 pt-16 lg:pt-24 pb-16">
					<header className="max-w-3xl">
						<h1 className="display-hero text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight text-gray-900">
							Simple, transparent pricing.
						</h1>
						<p className="mt-4 text-lg text-gray-600">Start free. Upgrade when you need more.</p>
					</header>

					<div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
						{/* Starter */}
						<div className="rounded-2xl border border-gray-200 bg-white p-6 elev-1">
							<h3 className="text-base font-semibold text-gray-900">Starter</h3>
							<div className="mt-2 text-3xl font-extrabold text-gray-900">$0/mo</div>
							<p className="mt-2 text-sm text-gray-600">TO BE DETERMINED</p>
							<Link to="/register" className="mt-6 inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors">Get started</Link>
						</div>

						{/* Pro (highlight) */}
						<div className="rounded-2xl border border-gray-200 bg-white p-6 elev-1 ring-2 ring-sedra">
							<h3 className="text-base font-semibold text-gray-900">Pro</h3>
							<div className="mt-2 text-3xl font-extrabold text-gray-900">$0/mo</div>
							<p className="mt-2 text-sm text-gray-600">TO BE DETERMINED</p>
							<Link to="/register" className="mt-6 inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors">Try Pro</Link>
						</div>

						{/* Business */}
						<div className="rounded-2xl border border-gray-200 bg-white p-6 elev-1">
							<h3 className="text-base font-semibold text-gray-900">Business</h3>
							<div className="mt-2 text-3xl font-extrabold text-gray-900">$0/mo</div>
							<p className="mt-2 text-sm text-gray-600">TO BE DETERMINED</p>
							<Link to="/register" className="mt-6 inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold text-white bg-sedra hover:bg-sedra-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra transition-colors">Get Business</Link>
						</div>
					</div>

					{/* FAQs placeholder */}
					<section className="mt-16 border-t border-gray-200 pt-10">
						<h2 className="text-lg font-semibold text-gray-900">FAQs</h2>
						<p className="mt-2 text-sm text-gray-600">Coming soon.</p>
					</section>
				</section>
			</main>
			<Footer />
		</div>
	);
};

export default PricingPage; 